<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import HomeMenu from '@/modules/home/components/HomeMenu.vue'
import OperationsMenu from '@/modules/operations/components/OperationsMenu.vue'
import InventoryMenu from '@/modules/inventory/components/InventoryMenu.vue'
import AdminMenu from '@/modules/admin/components/AdminMenu.vue'

const route = useRoute()
const currentModule = computed(() => route.meta.module)

const CurrentMenu = computed(() => {
  switch (currentModule.value) {
    case 'home': return HomeMenu
    case 'operations': return OperationsMenu
    case 'inventory': return InventoryMenu
    case 'admin': return AdminMenu

    default: return null
  }
})
</script>

<template>
  <component :is="CurrentMenu" />
</template>
